import Icon from "@react-native-vector-icons/material-design-icons";
import theme from "assets/theme";
import React from "react";
import { StyleSheet, Text, View } from "react-native";
import Dropdown from "webComponentsFormElements/inputs/Dropdown.component";

const classes = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 15,
    backgroundColor: theme.color.white,
    borderRadius: 8,
    padding: 10,
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    elevation: 3,
    zIndex: 1000,
  },
  label: {
    fontSize: theme.font.size.small,
    color: theme.color.darkGrey,
    fontWeight: theme.font.weight.medium,
    marginRight: 10,
  },
  dropdownContainer: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    zIndex: 1000,
  },
  icon: {
    marginRight: 8,
  },
  dropdownTextStyle: {
    fontSize: theme.font.size.small,
    color: theme.color.darkGrey,
    fontWeight: theme.font.weight.medium,
  },
});

export default function SortSelector({
  sortBy,
  onSortChange,
  organizationColor,
  options = [
    { value: "nameAsc", label: "Name A-Z" },
    { value: "nameDesc", label: "Name Z-A" },
    { value: "createdAtOldest", label: "Date Oldest First" },
    { value: "createdAtNewest", label: "Date Newest First" },
  ],
}) {
  return (
    <View style={classes.container}>
      <Icon
        name="sort"
        size={20}
        color={organizationColor || theme.color.primary}
        style={classes.icon}
      />
      <Text
        style={[
          classes.label,
          { color: organizationColor || theme.color.primary },
        ]}
      >
        Sort by:
      </Text>
      <View style={classes.dropdownContainer}>
        <Dropdown
          backgroundColor={theme.color.white}
          textStyle={[
            classes.dropdownTextStyle,
            { color: organizationColor || theme.color.primary },
          ]}
          options={options}
          selected={sortBy}
          onSelect={onSortChange}
        />
      </View>
    </View>
  );
}
